/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Demohess_Hochschulangehoerige28Inputs */

const en__field_enum_demohess_hochschulangehoerige28 = /** @type {(inputs: _Field_Enum_Demohess_Hochschulangehoerige28Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angehörige*r einer anderen Hochschule (nicht GU)`)
};

const de__field_enum_demohess_hochschulangehoerige28 = /** @type {(inputs: _Field_Enum_Demohess_Hochschulangehoerige28Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angehörige*r einer anderen Hochschule (nicht GU)`)
};

/**
* | output |
* | --- |
* | "Angehörige*r einer anderen Hochschule (nicht GU)" |
*
* @param {_Field_Enum_Demohess_Hochschulangehoerige28Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_demohess_hochschulangehoerige28 = /** @type {((inputs?: _Field_Enum_Demohess_Hochschulangehoerige28Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Demohess_Hochschulangehoerige28Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_demohess_hochschulangehoerige28(inputs)
	return de__field_enum_demohess_hochschulangehoerige28(inputs)
});
export { _field_enum_demohess_hochschulangehoerige28 as "_field_enum_DEMOHESS_HOCHSCHULANGEHOERIGE" }